'use strict';
var __createBinding =
  (this && this.__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (
          !desc ||
          ('get' in desc ? !m.__esModule : desc.writable || desc.configurable)
        ) {
          desc = {
            enumerable: true,
            get: function () {
              return m[k];
            },
          };
        }
        Object.defineProperty(o, k2, desc);
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });
var __setModuleDefault =
  (this && this.__setModuleDefault) ||
  (Object.create
    ? function (o, v) {
        Object.defineProperty(o, 'default', { enumerable: true, value: v });
      }
    : function (o, v) {
        o['default'] = v;
      });
var __importStar =
  (this && this.__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
Object.defineProperty(exports, '__esModule', { value: true });
exports.useForm = exports.useInternalForm = void 0;
const react_1 = __importStar(require('react'));
const rc_utils_1 = require('@hangar31/rc-utils');
const FormContext = react_1.default.createContext({});
const useInternalForm = () => react_1.default.useContext(FormContext);
exports.useInternalForm = useInternalForm;
const useForm = () => {
  const context = react_1.default.useContext(FormContext);
  return {
    fields: context.fields,
    setField: context.setField,
    setFields: context.setFields,
  };
};
exports.useForm = useForm;
function FormProvider({ children, defaultData }) {
  const [state, setState] = (0, react_1.useState)({
    changedData: {},
    errors: [],
    fields: JSON.parse(JSON.stringify(defaultData)),
    initialData: JSON.parse(JSON.stringify(defaultData)),
    status: 'WAITING',
  });
  const setFields = setters => {
    setState(s => {
      const fields = Object.assign({}, s.fields);
      const changedData = Object.assign({}, s.changedData);
      setters.forEach(setter => {
        (0, rc_utils_1.setByPath)(fields, setter[0], setter[1]);
        (0, rc_utils_1.setByPath)(changedData, setter[0], setter[1]);
      });
      return Object.assign(Object.assign({}, s), {
        changedData,
        errors: [],
        fields,
        status: 'CHANGED',
      });
    });
  };
  (0, react_1.useEffect)(() => {
    setState({
      changedData: {},
      errors: [],
      fields: JSON.parse(JSON.stringify(defaultData)),
      initialData: JSON.parse(JSON.stringify(defaultData)),
      status: 'WAITING',
    });
  }, [typeof window !== 'undefined' ? window.location.pathname : '']);
  const setField = (name, value) => setFields([[name, value]]);
  return react_1.default.createElement(
    FormContext.Provider,
    { value: Object.assign({ setField, setFields, setState }, state) },
    children
  );
}
exports.default = FormProvider;
//# sourceMappingURL=form.js.map
